/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2024
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

// client-extensions/result_enriching_response_observer

define(["underscore", "model/model_response_observer"], function(_, ModelResponseObserver) {
  var ResultEnrichingResponseObserver = ModelResponseObserver.extend({
    initialize: function() {
      this.enrichmentHandler = this._getResultPropertyEnrichmentHandler(this.observerOptions.handlerOptions);
      if (this.enrichmentHandler) this.enrichmentHandler.start();
    },

    getAdditionalModelOptions: function() {
      return _.extend({}, this.modelOptions, {
        resultPropertyEnrichmentHandler: this.enrichmentHandler
      });
    },

    finalize: function() {
      if (this.enrichmentHandler) this.enrichmentHandler.end();
    },

    _getResultPropertyEnrichmentHandler: function(handlerOptions) {
      if (!this.modelOptions || !this.modelOptions.clientExtensions) return;

      var clientExtensions = this.modelOptions.clientExtensions;
      var factory =
        clientExtensions.getResultPropertiesEnrichmentHandlerFactoryV1 &&
        clientExtensions.getResultPropertiesEnrichmentHandlerFactoryV1();

      return factory && _.isFunction(factory.createHandler) && factory.createHandler(handlerOptions);
    }
  });

  return ResultEnrichingResponseObserver;
});
